import { useSyncExternalStore } from "react";
import { getNotificationSounds, subscribeNotificationSounds } from "./notification-sounds";

export function useNotificationSounds() {
  return useSyncExternalStore(subscribeNotificationSounds, getNotificationSounds, () => true);
}
